import React from 'react';
import PropTypes from 'prop-types';
import { Box, Col, FlexRow } from '@edreamsodigeo/prisma-design-system';
import { useFlow } from '@edreamsodigeo/frontend-core';

export const PrimeInfoBanner = ({ children, icon }) => {
  const flow = useFlow();
  return (
    <Box
      px="small"
      py={flow === 'mobile' ? '1x_small' : 'base'}
      backgroundColor="primary.90"
    >
      <FlexRow gap={1} flexDirection="row" alignItems="center">
        <Col>{icon}</Col>
        <Col>{children}</Col>
      </FlexRow>
    </Box>
  );
};

PrimeInfoBanner.propTypes = {
  icon: PropTypes.element,
};
